/* eslint-disable max-len */

import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const IconSwitch: FC<Props> = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M8.75 6.24996C8.75 5.90478 9.02982 5.62496 9.375 5.62496H16.875C17.2202 5.62496 17.5 5.90478 17.5 6.24996C17.5 6.59514 17.2202 6.87496 16.875 6.87496H9.375C9.02982 6.87496 8.75 6.59514 8.75 6.24996Z"
      fill="#272756"
    />
    <path
      d="M9.375 13.125C9.02982 13.125 8.75 13.4048 8.75 13.75C8.75 14.0951 9.02982 14.375 9.375 14.375H16.875C17.2202 14.375 17.5 14.0951 17.5 13.75C17.5 13.4048 17.2202 13.125 16.875 13.125H9.375Z"
      fill="#272756"
    />
    <path
      d="M6.66665 6.24996C6.66665 6.7102 6.29355 7.08329 5.83331 7.08329H5.41665C4.95641 7.08329 4.58331 6.7102 4.58331 6.24996C4.58331 5.78972 4.95641 5.41663 5.41665 5.41663H5.83331C6.29355 5.41663 6.66665 5.78972 6.66665 6.24996Z"
      fill="#272756"
    />
    <path
      d="M6.66665 13.75C6.66665 14.2102 6.29355 14.5833 5.83331 14.5833H5.41665C4.95641 14.5833 4.58331 14.2102 4.58331 13.75C4.58331 13.2897 4.95641 12.9166 5.41665 12.9166H5.83331C6.29355 12.9166 6.66665 13.2897 6.66665 13.75Z"
      fill="#272756"
    />
  </svg>
);
